import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import throttle from "lodash.throttle";

import Button from "../button";
import Localization from "../../localization";
import IconLogo from "../icons/logo";
import IconCalendar from "../icons/calendar";
import IconLib from "../icons/lib";
import IconSearch from "../icons/search";
import IconBurguer from "../icons/burguer";

import { appLocales } from "../../localization";
import {
    changeLogin,
    changeSearch,
    changeMobileMenu,
} from "../../redux/actions/options";
import { getMe } from "../../redux/selectors/me";
import { getUrl } from "../../utils/helper";
import IconLogin from "../icons/login";

class Navigation extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            prevScrollpos: window.pageYOffset,
            visible: true,
            background: false,
        };

        this._handleScroll = throttle(this._handleScroll.bind(this), 300);
        this._onLoginPress = this._onLoginPress.bind(this);
        this._onMobileMenuPress = this._onMobileMenuPress.bind(this);
        this._onSearchPress = this._onSearchPress.bind(this);
    }

    componentDidMount() {
        window.addEventListener("scroll", this._handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this._handleScroll);
    }

    _handleScroll() {
        const { prevScrollpos } = this.state;

        const currentScrollPos = window.pageYOffset;
        let visible = prevScrollpos > currentScrollPos;

        let background = window.scrollY >= window.innerHeight - 200;

        if (prevScrollpos < 50) {
            visible = true;
        }

        if (
            location.pathname.includes(getUrl("account")) ||
            location.pathname.includes(getUrl("privacy")) ||
            location.pathname.includes(getUrl("terms")) ||
            location.pathname.includes(getUrl("cookies"))
        ) {
            background = true;
        }

        this.setState({
            prevScrollpos: currentScrollPos,
            visible,
            background,
        });
    }

    _onSearchPress() {
        this.props.changeSearch(true);
    }

    _onLoginPress() {
        this.props.changeLogin(true);
    }

    _renderButton(text, url, onClick, icon) {
        const { background } = this.state;

        let isActive = false;
        if (url) {
            isActive = location.pathname.split("/")[2] === url.split("/")[2];
        }

        let backgroundColor = "bg-blue";
        let borderColor = background
            ? "border-blue"
            : "border-white hover:border-blue";
        let textColor = background && !isActive ? "text-blue" : "text-white";
        if (isActive) {
            borderColor = "border-blue";
        }

        if (
            location.pathname.includes(getUrl("account/profile")) ||
            location.pathname.includes(getUrl("account/profile/edit")) ||
            location.pathname.includes(getUrl("account/artistic")) ||
            location.pathname.includes(getUrl("account/claim")) ||
            location.pathname.includes(getUrl("account/spaces")) ||
            location.pathname.includes(getUrl("account/technical"))
        ) {
            borderColor = "border-blue";
            textColor = "text-blue";
        }

        if (
            location.pathname.includes(getUrl("about")) ||
            location.pathname.includes(getUrl("spaces_booking"))
        ) {
            textColor = background && !isActive ? "text-orange" : "text-white";
            backgroundColor = "bg-orange";
            if (isActive) {
                borderColor = "border-orange";
            } else {
                borderColor = background
                    ? "border-orange"
                    : "border-white hover:border-orange";
            }
        } else if (location.pathname.includes(getUrl("artists"))) {
            textColor = background && !isActive ? "text-pink" : "text-white";
            backgroundColor = "bg-pink";
            if (isActive) {
                borderColor = "border-pink";
            } else {
                borderColor = background
                    ? "border-pink"
                    : "border-white hover:border-pink";
            }
        }

        let customStyle = "ml-4";
        let customWrapperStyle = "px-8 xl:px-15";

        return (
            <Button
                icon={icon}
                text={text}
                backgroundColor={isActive ? backgroundColor : "bg-transparent"}
                backgroundColorOver={backgroundColor}
                to={url}
                onClick={onClick}
                borderColor={borderColor}
                textStyle={
                    "font-bold text-15 2xl:text-17 z-10 transition hover-hover:group-hover:text-white " +
                    textColor
                }
                style={customStyle}
                wrapperStyle={customWrapperStyle}
            />
        );
    }

    _onMobileMenuPress() {
        const { isMobileMenuVisible } = this.props;

        if (isMobileMenuVisible) {
            this.props.changeMobileMenu(false);
        } else {
            this.props.changeMobileMenu(true);
        }
    }

    render() {
        const { locale, user, isMobileMenuVisible } = this.props;
        const { visible, background } = this.state;

        let baseClassName =
            "fixed top-0 left-0 right-0 z-20 transition transform";

        if (visible) {
            baseClassName += " translate-y-0";
        } else {
            baseClassName += " -translate-y-full";
        }

        if (background) baseClassName += " bg-white";

        let backgroundColor = "bg-blue";
        let borderColor = background
            ? "border-blue"
            : "border-white hover:border-blue";
        let textColor = background ? "text-blue" : "text-white";

        if (
            location.pathname.includes(getUrl("account/profile")) ||
            location.pathname.includes(getUrl("account/profile/edit")) ||
            location.pathname.includes(getUrl("account/artistic")) ||
            location.pathname.includes(getUrl("account/claim")) ||
            location.pathname.includes(getUrl("account/spaces")) ||
            location.pathname.includes(getUrl("account/technical"))
        ) {
            borderColor = "border-blue";
            textColor = "text-blue";
        }

        if (
            location.pathname.includes(getUrl("about")) ||
            location.pathname.includes(getUrl("spaces_booking"))
        ) {
            textColor = background ? "text-orange" : "text-white";
            backgroundColor = "bg-orange";
            borderColor = background
                ? "border-orange"
                : "border-white hover:border-orange";
        } else if (location.pathname.includes(getUrl("artists"))) {
            backgroundColor = "bg-pink";
            borderColor = "border-white hover:border-pink";
        }

        let textStyle =
            "font-bold text-17 z-10 transition hover-hover:group-hover:text-white " +
            textColor;
        let iconStyle =
            "w-25 h-20 z-10 transition hover-hover:group-hover:text-white " +
            textColor;

        const otherLocale = appLocales.filter((item) => item !== locale)[0];

        const userIconStyle = `w-25 h-20 z-10 transition hover-hover:group-hover:text-white ${
            background ? textColor : "text-white"
        }`;

        return (
            <div className={baseClassName}>
                <div className="flex justify-between px-16 xl:px-50 pt-30 xl:pt-40 pb-20">
                    <Link
                        title={"PAULO CUNHA E SILVA"}
                        to={getUrl("/")}
                        className="flex flex-col"
                    >
                        <IconLogo
                            className={
                                "w-140 xl:w-208 h-30 -ml-2 xl:ml-0 xl:h-46 " +
                                textColor
                            }
                        />
                        <p
                            className={
                                "font-judge font-bold mt-5 xl:mt-8 text-12 xl:text-17 " +
                                textColor
                            }
                        >
                            PAULO CUNHA E SILVA
                        </p>
                    </Link>
                    <div className="flex xl:hidden">
                        <Button
                            icon={
                                <IconBurguer
                                    opened={isMobileMenuVisible}
                                    color={
                                        background
                                            ? backgroundColor
                                            : "bg-white"
                                    }
                                />
                            }
                            backgroundColorOver={backgroundColor}
                            onClick={this._onMobileMenuPress}
                            borderColor={borderColor}
                            style={"w-50 ml-16"}
                        />
                    </div>
                    <div className="hidden xl:flex">
                        {this._renderButton(
                            Localization[locale].navigation.info,
                            getUrl("about")
                        )}
                        {this._renderButton(
                            Localization[locale].navigation.open_calls,
                            getUrl("opencalls")
                        )}
                        {this._renderButton(
                            Localization[locale].navigation.spaces,
                            getUrl("spaces_booking")
                        )}
                        {this._renderButton(
                            Localization[locale].navigation.classes,
                            getUrl("practices")
                        )}
                        {this._renderButton(
                            Localization[locale].navigation.blog,
                            getUrl("bookmarks")
                        )}
                        {this._renderButton(
                            Localization[locale].navigation.artists,
                            getUrl("artists")
                        )}
                        {user ? (
                            <Button
                                icon={<IconLogin className={userIconStyle} />}
                                backgroundColor={
                                    location.pathname.includes(
                                        getUrl("account/")
                                    )
                                        ? "bg-blue"
                                        : "bg-transparent"
                                }
                                backgroundColorOver={backgroundColor}
                                to={getUrl("account/profile")}
                                borderColor={borderColor}
                                style={"w-50 ml-4"}
                            />
                        ) : (
                            <Button
                                icon={<IconLogin className={iconStyle} />}
                                backgroundColorOver={backgroundColor}
                                onClick={this._onLoginPress}
                                borderColor={borderColor}
                                style={"w-50 ml-4"}
                            />
                        )}
                        <Button
                            text={otherLocale.toUpperCase()}
                            backgroundColorOver={backgroundColor}
                            onClick={() => {
                                let url = window.location.href.replace(
                                    "/" + this.props.locale,
                                    "/" + otherLocale
                                );

                                window.location.replace(url);
                            }}
                            borderColor={borderColor}
                            textStyle={textStyle}
                            style="ml-4"
                            wrapperStyle="px-15"
                        />
                        {/*<Button
                            icon={<IconCalendar className={iconStyle} />}
                            backgroundColor={
                                location.pathname.includes(getUrl("calendar"))
                                    ? "bg-blue"
                                    : "bg-transparent"
                            }
                            backgroundColorOver={backgroundColor}
                            to={getUrl("/calendar")}
                            borderColor={
                                location.pathname.includes(getUrl("calendar"))
                                    ? "border-blue"
                                    : borderColor
                            }
                            style={"w-50 ml-4"}
                            title={Localization[locale].home.calendar}
                        />*/}
                        <Button
                            icon={<IconSearch className={iconStyle} />}
                            backgroundColorOver={backgroundColor}
                            onClick={this._onSearchPress}
                            borderColor={borderColor}
                            style={"w-50 ml-4"}
                            title={Localization[locale].home.search}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

Navigation.defaultProps = {};

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    user: getMe(state),
    backgroundColor: state.app.backgroundColor,
    textColor: state.app.textColor,
    isMobileMenuVisible: state.options.isMobileMenuVisible,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeLogin,
            changeSearch,
            changeMobileMenu,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
